import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const UserContext = createContext();

export const useUser = () => {
  return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  // Fetch user data
  const fetchUser = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/users/me`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUser(data.user);
      } catch (error) {
        console.error("Failed to fetch user", error);
        logout();
      }
    }
    setLoading(false);
  };

  const login = async (credentials) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/dashboard-login`,
        credentials,
      );

      if (data?.token && data?.user) {
        setUser(data?.user);
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("token", data.token);
        return data;
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Login failed:", error);
      throw error.response ? error.response.data : new Error(error.message);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user"); // Clean up if exists
    localStorage.removeItem("token");
  };

  // Fetch user data on route change
  useEffect(() => {
    fetchUser();
  }, [location.pathname]);

  const value = {
    user,
    login,
    logout,
    loading,
  };

  return (
    <UserContext.Provider value={value}>
      {!loading && children}
    </UserContext.Provider>
  );
};
